import { useMutation } from 'react-query';

import {
  OrderDataErrorMessages,
  OrdersDataErrorCodes,
} from '@/constants/error_msg';
import { TABLET_API_ORIGIN } from '@/global/env';
import { getClient } from '@/lib/restClient';

export interface TriggerCSVGenerationParams {
  date_and_time_from: string;
  date_and_time_to: string;
  date_time_type: string;
  csv_type: string;
}

interface TriggerCSVGenerationResponse {
  job_id: string;
  status: string;
}

export const useTriggerCSVGeneration = () => {
  const { mutate, isLoading, error, isSuccess, data } = useMutation<
    TriggerCSVGenerationResponse,
    Error,
    TriggerCSVGenerationParams
  >(
    async (
      params: TriggerCSVGenerationParams
    ): Promise<TriggerCSVGenerationResponse> => {
      const restClient = getClient();
      return await restClient.post(
        `${TABLET_API_ORIGIN}/dashboard-api/order-data/trigger-csv-worker` as const,
        params
      );
    },
    {
      onError: (error) => {
        const message = (error as Error).message;
        alert(
          OrderDataErrorMessages[message as OrdersDataErrorCodes] || message
        );
      },
    }
  );

  const triggerCSVGeneration = (
    params: TriggerCSVGenerationParams
  ): TriggerCSVGenerationResponse | undefined => {
    mutate(params);
    return data;
  };

  return {
    triggerCSVGeneration,
    isLoading,
    error,
    isSuccess,
    data,
  };
};
